webpackJsonp([1],{

/***/ 213:
/***/ (function(module, exports) {

/* bling.js */

window.$ = document.querySelectorAll.bind(document);

Node.prototype.on = window.on = function (name, fn) {
    this.addEventListener(name, fn);
};

NodeList.prototype.__proto__ = Array.prototype;

NodeList.prototype.on = NodeList.prototype.addEventListener = function (name, fn) {
    this.forEach(function (elem, i) {
        elem.on(name, fn);
    });
};

/***/ }),

/***/ 214:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 219:
/***/ (function(module, exports) {

// import FontFaceObserver from 'fontfaceobserver'

// Disable if you use WebFonts
document.documentElement.className += " wf-loaded";

/**
 * Check if the User already visited the site and the Fonts were loaded
 * If not resolve all fonts, otherwise directly set the class to html
 */
/*
const fontA = new FontFaceObserver('fontA');
const fontB = new FontFaceObserver('fontB');

if (sessionStorage.fontsLoaded === true) {
    console.log('Fonts loaded via cache');
    alert('Fonts loaded via cache');
    document.documentElement.classList.add('wf-loaded');
} else {
    console.log('FontLoaded not in session storage');
    // Add all Variables defined above in the array of Promise.all
    Promise.all([fontA.load(), fontB.load()])
        .then(function() {
            console.log('Fonts loaded');
            document.documentElement.classList.add('wf-loaded');
            sessionStorage.fontsLoaded = true;
        })
        .catch((e) => {
            console.error(e);
            document.documentElement.classList.add('wf-failed');
            sessionStorage.fontsLoaded = false;
        });
}
*/

/**
 * Single Font Example
 fontA.load().then(function () {
    console.log('Fonts loaded');
    document.documentElement.classList.add('wf-loaded');
    sessionStorage.fontsLoaded = true;
}).catch(function () {
    console.error(e);
    document.documentElement.classList.add('wf-failed');
    sessionStorage.fontsLoaded = false;
});
 */

/***/ }),

/***/ 220:
/***/ (function(module, exports) {

//  --------------------------------------------------------
//  GoToUrl
//  --------------------------------------------------------

var goToUrl = function goToUrl(newLocation) {
    window.location = newLocation;
};

module.exports = goToUrl;

/***/ }),

/***/ 221:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {/* eslint-disable */
$('a[href*="#"]')
// Remove links that don't actually link to anything
.not('[href="#"]').not('[href="#0"]').click(function (event) {
  // On-page links
  if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
    // Figure out element to scroll to
    var target = $(this.hash);
    target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
    // Does a scroll target exist?
    if (target.length) {
      // Only prevent default if animation is actually gonna happen
      event.preventDefault();
      $('html, body').animate({
        scrollTop: target.offset().top - 60
      }, 1000, function () {
        // Callback after animation
        // Must change focus!
        var $target = $(target);
        $target.focus();
        if ($target.is(":focus")) {
          // Checking if the target was focused
          return false;
        } else {
          $target.attr('tabindex', '-1'); // Adding tabindex for elements not focusable
          $target.focus(); // Set focus again
        };
      });
    }
  }
});

if (window.location.hash) {
  setTimeout(function () {
    $('html, body').animate({
      scrollTop: $(window.location.hash).offset().top - 60
    }, 1000);
  }, 250);
}
/* eslint-enable */
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(38)))

/***/ }),

/***/ 222:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_owl_carousel__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_owl_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_owl_carousel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_baguettebox_js_dist_baguettebox__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_baguettebox_js_dist_baguettebox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__node_modules_baguettebox_js_dist_baguettebox__);
/**
 * Image Slider
 */

/* eslint-disable */



var imageCarousel = {
    cfg: {

        slider: '.js-imageCarousel',
        carouselOptions: {
            overlayBackgroundColor: 'rgba(255,255,255,0.8)'
        },
        sliderOptions: {
            // pullDrag: true,
            margin: 10,
            loop: false,
            // responsiveClass:true,
            touchDrag: true,
            mouseDrag: true,
            autoplay: false,
            // smartSpeed : 1500,
            autoplayHoverPause: true,
            navElement: 'div',
            navClass: ['swiper-button-prev', 'swiper-button-next'],
            navText: ['<span class="a-icon  a-icon--iconChevronLeft"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path fill="currentColor" d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12l4.58-4.59z"></path></svg></span>', '<span class="a-icon  a-icon--iconChevronRight"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path fill="currentColor" d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6-6-6z"></path></svg></span>'],
            //videoWidth: 600,
            responsive: {
                0: {
                    items: 2,
                    nav: true,
                    dots: false
                },
                700: {
                    items: 3,
                    nav: true,
                    dots: false
                },
                1000: {
                    items: 4,
                    nav: true,
                    dots: false
                },
                1200: {
                    items: 4,
                    nav: true,
                    dots: false
                }
            }
        }
    },

    init: function init() {

        var gallery = document.querySelector('.js-imageCarousel');
        if (gallery) {
            __WEBPACK_IMPORTED_MODULE_1__node_modules_baguettebox_js_dist_baguettebox___default.a.run('.js-imageCarousel', this.cfg.carouselOptions);
        }

        var $owl = $(this.cfg.slider).owlCarousel(this.cfg.sliderOptions);

        setTimeout(function () {
            $owl.trigger('refresh.owl.carousel');
        }, 500);
    }
};
/* eslint-enable */
/* harmony default export */ __webpack_exports__["a"] = (imageCarousel);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(38)))

/***/ }),

/***/ 99:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.typed.array-buffer.js
var es6_typed_array_buffer = __webpack_require__(100);
var es6_typed_array_buffer_default = /*#__PURE__*/__webpack_require__.n(es6_typed_array_buffer);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.typed.int8-array.js
var es6_typed_int8_array = __webpack_require__(101);
var es6_typed_int8_array_default = /*#__PURE__*/__webpack_require__.n(es6_typed_int8_array);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.typed.uint8-array.js
var es6_typed_uint8_array = __webpack_require__(106);
var es6_typed_uint8_array_default = /*#__PURE__*/__webpack_require__.n(es6_typed_uint8_array);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.typed.uint8-clamped-array.js
var es6_typed_uint8_clamped_array = __webpack_require__(107);
var es6_typed_uint8_clamped_array_default = /*#__PURE__*/__webpack_require__.n(es6_typed_uint8_clamped_array);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.typed.int16-array.js
var es6_typed_int16_array = __webpack_require__(108);
var es6_typed_int16_array_default = /*#__PURE__*/__webpack_require__.n(es6_typed_int16_array);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.typed.uint16-array.js
var es6_typed_uint16_array = __webpack_require__(109);
var es6_typed_uint16_array_default = /*#__PURE__*/__webpack_require__.n(es6_typed_uint16_array);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.typed.int32-array.js
var es6_typed_int32_array = __webpack_require__(110);
var es6_typed_int32_array_default = /*#__PURE__*/__webpack_require__.n(es6_typed_int32_array);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.typed.uint32-array.js
var es6_typed_uint32_array = __webpack_require__(111);
var es6_typed_uint32_array_default = /*#__PURE__*/__webpack_require__.n(es6_typed_uint32_array);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.typed.float32-array.js
var es6_typed_float32_array = __webpack_require__(112);
var es6_typed_float32_array_default = /*#__PURE__*/__webpack_require__.n(es6_typed_float32_array);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.typed.float64-array.js
var es6_typed_float64_array = __webpack_require__(113);
var es6_typed_float64_array_default = /*#__PURE__*/__webpack_require__.n(es6_typed_float64_array);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.map.js
var es6_map = __webpack_require__(114);
var es6_map_default = /*#__PURE__*/__webpack_require__.n(es6_map);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.set.js
var es6_set = __webpack_require__(116);
var es6_set_default = /*#__PURE__*/__webpack_require__.n(es6_set);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.weak-map.js
var es6_weak_map = __webpack_require__(117);
var es6_weak_map_default = /*#__PURE__*/__webpack_require__.n(es6_weak_map);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.weak-set.js
var es6_weak_set = __webpack_require__(118);
var es6_weak_set_default = /*#__PURE__*/__webpack_require__.n(es6_weak_set);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.reflect.apply.js
var es6_reflect_apply = __webpack_require__(119);
var es6_reflect_apply_default = /*#__PURE__*/__webpack_require__.n(es6_reflect_apply);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.reflect.construct.js
var es6_reflect_construct = __webpack_require__(120);
var es6_reflect_construct_default = /*#__PURE__*/__webpack_require__.n(es6_reflect_construct);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.reflect.define-property.js
var es6_reflect_define_property = __webpack_require__(122);
var es6_reflect_define_property_default = /*#__PURE__*/__webpack_require__.n(es6_reflect_define_property);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.reflect.delete-property.js
var es6_reflect_delete_property = __webpack_require__(123);
var es6_reflect_delete_property_default = /*#__PURE__*/__webpack_require__.n(es6_reflect_delete_property);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.reflect.get.js
var es6_reflect_get = __webpack_require__(124);
var es6_reflect_get_default = /*#__PURE__*/__webpack_require__.n(es6_reflect_get);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.reflect.get-own-property-descriptor.js
var es6_reflect_get_own_property_descriptor = __webpack_require__(125);
var es6_reflect_get_own_property_descriptor_default = /*#__PURE__*/__webpack_require__.n(es6_reflect_get_own_property_descriptor);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.reflect.get-prototype-of.js
var es6_reflect_get_prototype_of = __webpack_require__(126);
var es6_reflect_get_prototype_of_default = /*#__PURE__*/__webpack_require__.n(es6_reflect_get_prototype_of);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.reflect.has.js
var es6_reflect_has = __webpack_require__(127);
var es6_reflect_has_default = /*#__PURE__*/__webpack_require__.n(es6_reflect_has);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.reflect.is-extensible.js
var es6_reflect_is_extensible = __webpack_require__(128);
var es6_reflect_is_extensible_default = /*#__PURE__*/__webpack_require__.n(es6_reflect_is_extensible);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.reflect.own-keys.js
var es6_reflect_own_keys = __webpack_require__(129);
var es6_reflect_own_keys_default = /*#__PURE__*/__webpack_require__.n(es6_reflect_own_keys);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.reflect.prevent-extensions.js
var es6_reflect_prevent_extensions = __webpack_require__(130);
var es6_reflect_prevent_extensions_default = /*#__PURE__*/__webpack_require__.n(es6_reflect_prevent_extensions);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.reflect.set.js
var es6_reflect_set = __webpack_require__(131);
var es6_reflect_set_default = /*#__PURE__*/__webpack_require__.n(es6_reflect_set);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.reflect.set-prototype-of.js
var es6_reflect_set_prototype_of = __webpack_require__(132);
var es6_reflect_set_prototype_of_default = /*#__PURE__*/__webpack_require__.n(es6_reflect_set_prototype_of);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.promise.js
var es6_promise = __webpack_require__(133);
var es6_promise_default = /*#__PURE__*/__webpack_require__.n(es6_promise);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.symbol.js
var es6_symbol = __webpack_require__(137);
var es6_symbol_default = /*#__PURE__*/__webpack_require__.n(es6_symbol);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.freeze.js
var es6_object_freeze = __webpack_require__(140);
var es6_object_freeze_default = /*#__PURE__*/__webpack_require__.n(es6_object_freeze);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.seal.js
var es6_object_seal = __webpack_require__(141);
var es6_object_seal_default = /*#__PURE__*/__webpack_require__.n(es6_object_seal);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.prevent-extensions.js
var es6_object_prevent_extensions = __webpack_require__(142);
var es6_object_prevent_extensions_default = /*#__PURE__*/__webpack_require__.n(es6_object_prevent_extensions);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.is-frozen.js
var es6_object_is_frozen = __webpack_require__(143);
var es6_object_is_frozen_default = /*#__PURE__*/__webpack_require__.n(es6_object_is_frozen);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.is-sealed.js
var es6_object_is_sealed = __webpack_require__(144);
var es6_object_is_sealed_default = /*#__PURE__*/__webpack_require__.n(es6_object_is_sealed);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.is-extensible.js
var es6_object_is_extensible = __webpack_require__(145);
var es6_object_is_extensible_default = /*#__PURE__*/__webpack_require__.n(es6_object_is_extensible);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.get-own-property-descriptor.js
var es6_object_get_own_property_descriptor = __webpack_require__(146);
var es6_object_get_own_property_descriptor_default = /*#__PURE__*/__webpack_require__.n(es6_object_get_own_property_descriptor);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.get-prototype-of.js
var es6_object_get_prototype_of = __webpack_require__(147);
var es6_object_get_prototype_of_default = /*#__PURE__*/__webpack_require__.n(es6_object_get_prototype_of);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.keys.js
var es6_object_keys = __webpack_require__(148);
var es6_object_keys_default = /*#__PURE__*/__webpack_require__.n(es6_object_keys);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.get-own-property-names.js
var es6_object_get_own_property_names = __webpack_require__(149);
var es6_object_get_own_property_names_default = /*#__PURE__*/__webpack_require__.n(es6_object_get_own_property_names);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.assign.js
var es6_object_assign = __webpack_require__(150);
var es6_object_assign_default = /*#__PURE__*/__webpack_require__.n(es6_object_assign);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.is.js
var es6_object_is = __webpack_require__(151);
var es6_object_is_default = /*#__PURE__*/__webpack_require__.n(es6_object_is);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.set-prototype-of.js
var es6_object_set_prototype_of = __webpack_require__(153);
var es6_object_set_prototype_of_default = /*#__PURE__*/__webpack_require__.n(es6_object_set_prototype_of);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.function.name.js
var es6_function_name = __webpack_require__(154);
var es6_function_name_default = /*#__PURE__*/__webpack_require__.n(es6_function_name);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.string.raw.js
var es6_string_raw = __webpack_require__(155);
var es6_string_raw_default = /*#__PURE__*/__webpack_require__.n(es6_string_raw);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.string.from-code-point.js
var es6_string_from_code_point = __webpack_require__(156);
var es6_string_from_code_point_default = /*#__PURE__*/__webpack_require__.n(es6_string_from_code_point);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.string.code-point-at.js
var es6_string_code_point_at = __webpack_require__(157);
var es6_string_code_point_at_default = /*#__PURE__*/__webpack_require__.n(es6_string_code_point_at);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.string.repeat.js
var es6_string_repeat = __webpack_require__(159);
var es6_string_repeat_default = /*#__PURE__*/__webpack_require__.n(es6_string_repeat);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.string.starts-with.js
var es6_string_starts_with = __webpack_require__(160);
var es6_string_starts_with_default = /*#__PURE__*/__webpack_require__.n(es6_string_starts_with);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.string.ends-with.js
var es6_string_ends_with = __webpack_require__(161);
var es6_string_ends_with_default = /*#__PURE__*/__webpack_require__.n(es6_string_ends_with);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.string.includes.js
var es6_string_includes = __webpack_require__(162);
var es6_string_includes_default = /*#__PURE__*/__webpack_require__.n(es6_string_includes);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.regexp.flags.js
var es6_regexp_flags = __webpack_require__(163);
var es6_regexp_flags_default = /*#__PURE__*/__webpack_require__.n(es6_regexp_flags);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.regexp.match.js
var es6_regexp_match = __webpack_require__(165);
var es6_regexp_match_default = /*#__PURE__*/__webpack_require__.n(es6_regexp_match);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.regexp.replace.js
var es6_regexp_replace = __webpack_require__(166);
var es6_regexp_replace_default = /*#__PURE__*/__webpack_require__.n(es6_regexp_replace);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.regexp.split.js
var es6_regexp_split = __webpack_require__(167);
var es6_regexp_split_default = /*#__PURE__*/__webpack_require__.n(es6_regexp_split);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.regexp.search.js
var es6_regexp_search = __webpack_require__(168);
var es6_regexp_search_default = /*#__PURE__*/__webpack_require__.n(es6_regexp_search);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.array.from.js
var es6_array_from = __webpack_require__(169);
var es6_array_from_default = /*#__PURE__*/__webpack_require__.n(es6_array_from);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.array.of.js
var es6_array_of = __webpack_require__(170);
var es6_array_of_default = /*#__PURE__*/__webpack_require__.n(es6_array_of);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.array.copy-within.js
var es6_array_copy_within = __webpack_require__(171);
var es6_array_copy_within_default = /*#__PURE__*/__webpack_require__.n(es6_array_copy_within);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.array.find.js
var es6_array_find = __webpack_require__(172);
var es6_array_find_default = /*#__PURE__*/__webpack_require__.n(es6_array_find);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.array.find-index.js
var es6_array_find_index = __webpack_require__(173);
var es6_array_find_index_default = /*#__PURE__*/__webpack_require__.n(es6_array_find_index);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.array.fill.js
var es6_array_fill = __webpack_require__(174);
var es6_array_fill_default = /*#__PURE__*/__webpack_require__.n(es6_array_fill);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.array.iterator.js
var es6_array_iterator = __webpack_require__(63);
var es6_array_iterator_default = /*#__PURE__*/__webpack_require__.n(es6_array_iterator);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.number.is-finite.js
var es6_number_is_finite = __webpack_require__(175);
var es6_number_is_finite_default = /*#__PURE__*/__webpack_require__.n(es6_number_is_finite);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.number.is-integer.js
var es6_number_is_integer = __webpack_require__(176);
var es6_number_is_integer_default = /*#__PURE__*/__webpack_require__.n(es6_number_is_integer);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.number.is-safe-integer.js
var es6_number_is_safe_integer = __webpack_require__(177);
var es6_number_is_safe_integer_default = /*#__PURE__*/__webpack_require__.n(es6_number_is_safe_integer);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.number.is-nan.js
var es6_number_is_nan = __webpack_require__(178);
var es6_number_is_nan_default = /*#__PURE__*/__webpack_require__.n(es6_number_is_nan);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.number.epsilon.js
var es6_number_epsilon = __webpack_require__(179);
var es6_number_epsilon_default = /*#__PURE__*/__webpack_require__.n(es6_number_epsilon);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.number.min-safe-integer.js
var es6_number_min_safe_integer = __webpack_require__(180);
var es6_number_min_safe_integer_default = /*#__PURE__*/__webpack_require__.n(es6_number_min_safe_integer);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.number.max-safe-integer.js
var es6_number_max_safe_integer = __webpack_require__(181);
var es6_number_max_safe_integer_default = /*#__PURE__*/__webpack_require__.n(es6_number_max_safe_integer);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.math.acosh.js
var es6_math_acosh = __webpack_require__(182);
var es6_math_acosh_default = /*#__PURE__*/__webpack_require__.n(es6_math_acosh);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.math.asinh.js
var es6_math_asinh = __webpack_require__(183);
var es6_math_asinh_default = /*#__PURE__*/__webpack_require__.n(es6_math_asinh);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.math.atanh.js
var es6_math_atanh = __webpack_require__(184);
var es6_math_atanh_default = /*#__PURE__*/__webpack_require__.n(es6_math_atanh);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.math.cbrt.js
var es6_math_cbrt = __webpack_require__(185);
var es6_math_cbrt_default = /*#__PURE__*/__webpack_require__.n(es6_math_cbrt);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.math.clz32.js
var es6_math_clz32 = __webpack_require__(186);
var es6_math_clz32_default = /*#__PURE__*/__webpack_require__.n(es6_math_clz32);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.math.cosh.js
var es6_math_cosh = __webpack_require__(187);
var es6_math_cosh_default = /*#__PURE__*/__webpack_require__.n(es6_math_cosh);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.math.expm1.js
var es6_math_expm1 = __webpack_require__(188);
var es6_math_expm1_default = /*#__PURE__*/__webpack_require__.n(es6_math_expm1);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.math.fround.js
var es6_math_fround = __webpack_require__(189);
var es6_math_fround_default = /*#__PURE__*/__webpack_require__.n(es6_math_fround);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.math.hypot.js
var es6_math_hypot = __webpack_require__(191);
var es6_math_hypot_default = /*#__PURE__*/__webpack_require__.n(es6_math_hypot);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.math.imul.js
var es6_math_imul = __webpack_require__(192);
var es6_math_imul_default = /*#__PURE__*/__webpack_require__.n(es6_math_imul);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.math.log1p.js
var es6_math_log1p = __webpack_require__(193);
var es6_math_log1p_default = /*#__PURE__*/__webpack_require__.n(es6_math_log1p);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.math.log10.js
var es6_math_log10 = __webpack_require__(194);
var es6_math_log10_default = /*#__PURE__*/__webpack_require__.n(es6_math_log10);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.math.log2.js
var es6_math_log2 = __webpack_require__(195);
var es6_math_log2_default = /*#__PURE__*/__webpack_require__.n(es6_math_log2);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.math.sign.js
var es6_math_sign = __webpack_require__(196);
var es6_math_sign_default = /*#__PURE__*/__webpack_require__.n(es6_math_sign);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.math.sinh.js
var es6_math_sinh = __webpack_require__(197);
var es6_math_sinh_default = /*#__PURE__*/__webpack_require__.n(es6_math_sinh);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.math.tanh.js
var es6_math_tanh = __webpack_require__(198);
var es6_math_tanh_default = /*#__PURE__*/__webpack_require__.n(es6_math_tanh);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.math.trunc.js
var es6_math_trunc = __webpack_require__(199);
var es6_math_trunc_default = /*#__PURE__*/__webpack_require__.n(es6_math_trunc);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.array.includes.js
var es7_array_includes = __webpack_require__(200);
var es7_array_includes_default = /*#__PURE__*/__webpack_require__.n(es7_array_includes);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.object.values.js
var es7_object_values = __webpack_require__(201);
var es7_object_values_default = /*#__PURE__*/__webpack_require__.n(es7_object_values);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.object.entries.js
var es7_object_entries = __webpack_require__(202);
var es7_object_entries_default = /*#__PURE__*/__webpack_require__.n(es7_object_entries);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.object.get-own-property-descriptors.js
var es7_object_get_own_property_descriptors = __webpack_require__(203);
var es7_object_get_own_property_descriptors_default = /*#__PURE__*/__webpack_require__.n(es7_object_get_own_property_descriptors);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.string.pad-start.js
var es7_string_pad_start = __webpack_require__(204);
var es7_string_pad_start_default = /*#__PURE__*/__webpack_require__.n(es7_string_pad_start);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.string.pad-end.js
var es7_string_pad_end = __webpack_require__(205);
var es7_string_pad_end_default = /*#__PURE__*/__webpack_require__.n(es7_string_pad_end);

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.timers.js
var web_timers = __webpack_require__(206);
var web_timers_default = /*#__PURE__*/__webpack_require__.n(web_timers);

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.immediate.js
var web_immediate = __webpack_require__(207);
var web_immediate_default = /*#__PURE__*/__webpack_require__.n(web_immediate);

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom.iterable.js
var web_dom_iterable = __webpack_require__(208);
var web_dom_iterable_default = /*#__PURE__*/__webpack_require__.n(web_dom_iterable);

// EXTERNAL MODULE: ./node_modules/regenerator-runtime/runtime.js
var runtime = __webpack_require__(209);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);

// EXTERNAL MODULE: ./node_modules/svgxuse/svgxuse.js
var svgxuse = __webpack_require__(211);
var svgxuse_default = /*#__PURE__*/__webpack_require__.n(svgxuse);

// EXTERNAL MODULE: ./node_modules/object-fit-images/dist/ofi.common-js.js
var ofi_common_js = __webpack_require__(212);
var ofi_common_js_default = /*#__PURE__*/__webpack_require__.n(ofi_common_js);

// EXTERNAL MODULE: ./___src/assets/js/lib/bling.js
var bling = __webpack_require__(213);
var bling_default = /*#__PURE__*/__webpack_require__.n(bling);

// EXTERNAL MODULE: ./___src/assets/css/app.scss
var app = __webpack_require__(214);
var app_default = /*#__PURE__*/__webpack_require__.n(app);

// CONCATENATED MODULE: ./___src/assets/js/scripts/bodyclass.js
/**
 * bodyClass
 */

var bodyClass = {
    cfg: {
        body: document.body,
        steps: 500,
        duration: 3000,
        timer: 0,
        i: 1
    },

    setClass: function setClass() {
        this.cfg.body.classList.add('is-' + this.cfg.i * this.cfg.steps + 'ms');
        this.cfg.i += 1;
    },
    timer: function timer() {
        var _this = this;

        while (this.cfg.timer <= this.cfg.duration) {
            if (this.cfg.timer === 0) {
                this.cfg.body.classList.add('is-ready');
            } else {
                setTimeout(function () {
                    _this.setClass();
                    window.dispatchEvent(new Event('resize'));
                }, this.cfg.timer);
            }
            this.cfg.timer += this.cfg.steps;
        }
    },
    init: function init() {
        this.timer();
        // trigger resize
    }
};

/* harmony default export */ var bodyclass = (bodyClass);
// CONCATENATED MODULE: ./___src/assets/js/scripts/disableHover.js
/**
 * disableHover
 */

var disableHover = {
    cfg: {
        body: document.body,
        timer: ''
    },

    setClasses: function setClasses() {
        var _this = this;

        clearTimeout(this.cfg.timer);
        if (!this.cfg.body.classList.contains('no-hover')) {
            this.cfg.body.classList.add('no-hover');
        }
        this.cfg.timer = setTimeout(function () {
            _this.cfg.body.classList.remove('no-hover');
        }, 250);
    },
    init: function init() {
        window.addEventListener('scroll', this.setClasses.bind(this), false);
    }
};

/* harmony default export */ var scripts_disableHover = (disableHover);
// EXTERNAL MODULE: ./node_modules/bowser/src/bowser.js
var bowser = __webpack_require__(215);
var bowser_default = /*#__PURE__*/__webpack_require__.n(bowser);

// CONCATENATED MODULE: ./___src/assets/js/scripts/bowser.js
/**
 * preloader
 */



var browserDetect = {
    cfg: {
        customOutput: true,
        docHead: document.querySelector('html'),
        version: bowser_default.a.version.toLowerCase().replace(' ', '-').split('.', 1)[0],
        name: bowser_default.a.name.toLowerCase().replace(' ', '-')
    },

    detectBrowser: function detectBrowser() {
        if (this.cfg.customOutput) {
            // Use the switch condition if you want to customize the output
            switch (bowser_default.a.name) {
                case 'Microsoft Edge':
                    this.cfg.docHead.classList.add('edge', 'edge-' + this.cfg.version);
                    break;

                case 'Internet Explorer':
                    this.cfg.docHead.classList.add('ie', 'ie-' + this.cfg.version);
                    break;

                case 'Firefox':
                    this.cfg.docHead.classList.add('firefox', 'firefox-' + this.cfg.version);
                    break;

                case 'Safari':
                    this.cfg.docHead.classList.add('safari', 'safari-' + this.cfg.version);
                    break;

                case 'Chrome':
                    this.cfg.docHead.classList.add('chrome', 'chrome-' + this.cfg.version);
                    break;

                default:
            }

            // Generate Class for Browser with the old CSS Grid Spec
            var oldSpecBrowser = ['internet-explorer-10', 'internet-explorer-11', 'microsoft-edge-12', 'microsoft-edge-13', 'microsoft-edge-14', 'microsoft-edge-15'];

            if (oldSpecBrowser.includes(this.cfg.name + '-' + this.cfg.version)) {
                this.cfg.docHead.classList.add('t-oldies');
            }
        } else {
            // Generate Classes based on Browser and BrowserVersion
            this.cfg.docHead.classList.add(this.cfg.name, this.cfg.name + '-' + this.cfg.version);
        }
    },
    init: function init() {
        this.detectBrowser();
    }
};

/* harmony default export */ var scripts_bowser = (browserDetect);
// CONCATENATED MODULE: ./___src/assets/js/scripts/resizeClass.js
/**
 * bodyClass
 */

var resizeClass = {
    cfg: {
        body: document.body,
        timer: null
    },

    isDoneResizing: function isDoneResizing() {
        this.cfg.body.classList.remove('is-resizing');
        this.cfg.body.classList.add('is-resized');
    },
    isResizing: function isResizing() {
        this.cfg.body.classList.add('is-resizing');
        this.cfg.body.classList.remove('is-resized');
    },
    init: function init() {
        var _this = this;

        window.addEventListener('resize', function () {
            _this.isResizing();

            clearTimeout(_this.cfg.timer);
            _this.cfg.timer = setTimeout(function () {
                _this.isDoneResizing();
            }, 250);
        });
    }
};

/* harmony default export */ var scripts_resizeClass = (resizeClass);
// EXTERNAL MODULE: ./node_modules/lazysizes/lazysizes.js
var lazysizes = __webpack_require__(71);
var lazysizes_default = /*#__PURE__*/__webpack_require__.n(lazysizes);

// EXTERNAL MODULE: ./node_modules/lazysizes/plugins/bgset/ls.bgset.js
var ls_bgset = __webpack_require__(217);
var ls_bgset_default = /*#__PURE__*/__webpack_require__.n(ls_bgset);

// EXTERNAL MODULE: ./node_modules/lazysizes/plugins/respimg/ls.respimg.js
var ls_respimg = __webpack_require__(218);
var ls_respimg_default = /*#__PURE__*/__webpack_require__.n(ls_respimg);

// CONCATENATED MODULE: ./___src/assets/js/scripts/lazyloading.js
/**
 * Lazy Loading
 */

// Dependencies




// Settings
window.lazySizesConfig = window.lazySizesConfig || {};
window.lazySizesConfig.expand = 500; // default 360-500
window.lazySizesConfig.expFactor = 1.7; // default: 1.7
// EXTERNAL MODULE: ./___src/assets/js/scripts/fontfaceobserver.js
var fontfaceobserver = __webpack_require__(219);
var fontfaceobserver_default = /*#__PURE__*/__webpack_require__.n(fontfaceobserver);

// CONCATENATED MODULE: ./___src/assets/js/scripts/triggerResize.js
/**
 * triggerResize
 */

/* eslint-disable */
var triggerResize = {
    init: function init() {
        window.addEventListener('load', function () {
            window.dispatchEvent(new Event('resize'));
        });
    }
};
/* eslint-enable */
/* harmony default export */ var scripts_triggerResize = (triggerResize);
// EXTERNAL MODULE: ./___src/assets/js/lib/goToUrl.js
var goToUrl = __webpack_require__(220);
var goToUrl_default = /*#__PURE__*/__webpack_require__.n(goToUrl);

// CONCATENATED MODULE: ./___src/assets/js/scripts/pagetransition.js
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/**
 * Page Transitions
 */

// Dependencies
// import Velocity from 'velocity-animate';


// Vars
var siteURL = window.location.protocol + '//' + window.location.host;
var triggers = [].concat(_toConsumableArray(document.querySelectorAll('a[href^="' + siteURL + '"]:not([href*="#"]):not([itemprop="contentUrl"])')));

triggers.forEach(function (trigger) {
    // Click Event
    var dragged = 0;
    trigger.addEventListener('mousedown', function () {
        dragged = 0;
    }, false);
    trigger.addEventListener('mousemove', function () {
        dragged = 1;
    }, false);
    trigger.addEventListener('mouseup', function (event) {
        // eslint-disable-line
        if (dragged === 0) {
            if (!(event.ctrlKey || event.metaKey || event.which === 2)) {
                var newLocation = trigger.getAttribute('href');
                event.preventDefault();

                // Set Transition Class
                document.body.classList.add('js-pageTransition');
                // Velocity(document.body, 'scroll', { duration: 250 }, 'easeOutCubic');

                // Go to New Page
                setTimeout(function () {
                    goToUrl_default()(newLocation);
                }, 150);
            }
        }
    }, false);
});

window.addEventListener('pageshow', function () {
    // check if document is loaded from cache (works only live)
    // if (event.persisted) {
    document.body.classList.remove('js-pageTransition');
    // }
});
// EXTERNAL MODULE: ./___src/assets/js/scripts/smoothScroll.js
var smoothScroll = __webpack_require__(221);
var smoothScroll_default = /*#__PURE__*/__webpack_require__.n(smoothScroll);

// CONCATENATED MODULE: ./___src/assets/js/partials/scripts.js
/**
 * Scripts
 */

// import example from '../scripts/example';







// import cookiebar from '../scripts/cookiebar';
// import klaro from '../scripts/klaro';




// Modules Array
var scriptsArray = [bodyclass, scripts_disableHover, scripts_bowser, scripts_resizeClass,
// cookiebar,
scripts_triggerResize];

var scripts = {
    // Scripts
    Scripts: function Scripts() {
        if (scriptsArray.length > 0 && scriptsArray !== undefined) {
            scriptsArray.forEach(function (script) {
                script.init();
            });
        }
    },
    init: function init() {
        this.Scripts();
    }
};

/* harmony default export */ var partials_scripts = (scripts);
// CONCATENATED MODULE: ./___src/assets/js/partials/templates.js
/**
 * templates
 */

// Import Templats
// import toggleContent from '../../../templates/_templates/toggleContent/_main'

// Modules Array
var templatesArray = [
    // toggleContent
];

var templates = {
    // Modules
    Templates: function Templates() {
        if (templatesArray.length > 0 && templatesArray !== undefined) {
            templatesArray.forEach(function (template) {
                template.init();
            });
        }
    },
    init: function init() {
        this.Templates();
    }
};

/* harmony default export */ var partials_templates = (templates);
// CONCATENATED MODULE: ./___src/templates/_atoms/preloader/_script.js
/**
 * preloader
 */

var preloader = {
    cfg: {
        body: document.getElementsByTagName('body')[0],
        bar: document.querySelector('.a-preloader'),
        states: {
            loading: 'is-loading',
            interact: 'is-interactive',
            complete: 'is-complete'
        },
        barstates: {
            loading: 'a-preloader--loading',
            complete: 'a-preloader--complete'
        }
    },

    stateLoading: function stateLoading() {
        this.cfg.body.classList.add(this.cfg.states.loading);

        // Start Preloader Bar
        this.cfg.bar.classList.add(this.cfg.barstates.loading);
    },
    stateInteractive: function stateInteractive() {
        this.cfg.body.classList.remove(this.cfg.states.loading);
        this.cfg.body.classList.add(this.cfg.states.interact);
    },
    stateComplete: function stateComplete() {
        var _this = this;

        setTimeout(function () {
            // Change Classes for Preloader Bar
            _this.cfg.bar.classList.remove(_this.cfg.barstates.loading);
            _this.cfg.bar.classList.add(_this.cfg.barstates.complete);
        }, 125);

        setTimeout(function () {
            _this.cfg.body.classList.remove(_this.cfg.states.interact);
            _this.cfg.body.classList.add(_this.cfg.states.complete);
        }, 500);
    },
    progressLoader: function progressLoader() {
        var _this2 = this;

        this.stateLoading();
        this.stateInteractive();

        document.onreadystatechange = function () {
            if (document.readyState === 'complete') {
                _this2.stateComplete();
            }
        };
    },
    init: function init() {
        if (!this.cfg.body.classList.contains('is-livePreview') && document.getElementsByTagName('html')[0].classList.contains('js')) {
            this.progressLoader();
        }
    }
};

/* harmony default export */ var _script = (preloader);
// CONCATENATED MODULE: ./___src/templates/_atoms/toggle/_script.js
/**
*toggle
 */
/* eslint-disable */
var toggle = {
    cfg: {
        name: 'toggle',
        selectors: {
            toggle: '.js-toggle',
            closers: '.o-pageContent, .o-pageFooter, .m-overlay__link'
        }
    },

    init: function init() {
        var selectors = document.querySelectorAll(this.cfg.selectors.toggle);
        var closers = document.querySelectorAll(this.cfg.selectors.closers);
        window.onload = function () {
            selectors.addEventListener('click', function () {
                document.body.classList.toggle('is-overlayOpen');

                closers.addEventListener('click', function (event) {
                    document.body.classList.remove('is-overlayOpen');
                });
            });
        };
    }
};

/* harmony default export */ var toggle__script = (toggle);
// EXTERNAL MODULE: ./___src/templates/_organisms/imageCarousel/_script.js
var imageCarousel__script = __webpack_require__(222);

// EXTERNAL MODULE: ./node_modules/flickity/js/index.js
var js = __webpack_require__(225);
var js_default = /*#__PURE__*/__webpack_require__.n(js);

// CONCATENATED MODULE: ./___src/templates/_organisms/imageSlider/_script.js
function _script__toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/**
 * Image Slider
 */



var imageSlider = {
    cfg: {
        slider: '.js-imageSlider',
        sliderOptions: {
            cellAlign: 'left',
            contain: true,
            draggable: true,
            friction: 1,
            lazyLoad: 2,
            selectedAttraction: 0.1,
            groupCells: false,
            setGallerySize: true,
            imagesLoaded: true,
            prevNextButtons: true,
            pageDots: true,
            wrapAround: false
            // watchCSS: true
        }
    },

    init: function init() {
        var _this = this;

        window.addEventListener('load', function () {
            var sliders = [].concat(_script__toConsumableArray(document.querySelectorAll(_this.cfg.slider)));
            if (sliders) {
                sliders.forEach(function (slider) {
                    var flkty = new js_default.a(slider, _this.cfg.sliderOptions);
                    flkty.resize();

                    setTimeout(function () {
                        flkty.resize();
                        slider.classList.add('is-ready');
                    }, 1000);
                });
            }
        });
    }
};

/* harmony default export */ var imageSlider__script = (imageSlider);
// EXTERNAL MODULE: ./node_modules/photoswipe/dist/photoswipe.js
var photoswipe = __webpack_require__(237);
var photoswipe_default = /*#__PURE__*/__webpack_require__.n(photoswipe);

// EXTERNAL MODULE: ./node_modules/photoswipe/dist/photoswipe-ui-default.js
var photoswipe_ui_default = __webpack_require__(238);
var photoswipe_ui_default_default = /*#__PURE__*/__webpack_require__.n(photoswipe_ui_default);

// CONCATENATED MODULE: ./___src/templates/_organisms/imageGallery/_script.js
/**
 * imageGallery (Photoswipe
 */

// Dependencies



/* eslint-disable */
var imageGallery = {
    creatGallery: function creatGallery(gallerySelector) {
        // parse slide data (url, title, size ...) from DOM elements
        // (children of gallerySelector)
        var parseThumbnailElements = function parseThumbnailElements(el) {
            var thumbElements = el.childNodes;
            var numNodes = thumbElements.length;
            var items = [];
            var figureEl = void 0;
            var linkEl = void 0;
            var size = void 0;
            var item = void 0;

            for (var i = 0; i < numNodes; i++) {

                figureEl = thumbElements[i]; // <figure> element

                // include only element nodes
                if (figureEl.nodeType !== 1) {
                    continue;
                }

                linkEl = figureEl.getElementsByTagName('a')[0]; // <a> element

                console.log(linkEl);
                console.log(figureEl);

                size = linkEl.getAttribute('data-size').split('x');

                // create slide object
                item = {
                    src: linkEl.getAttribute('href'),
                    w: parseInt(size[0], 10),
                    h: parseInt(size[1], 10)
                };

                if (figureEl.children.length > 1) {
                    // <figcaption> content
                    item.title = figureEl.children[1].innerHTML;
                }

                console.log(figureEl.children.length);

                if (linkEl.children.length > 0) {
                    // <img> thumbnail element, retrieving thumbnail url
                    item.msrc = linkEl.children[0].getAttribute('data-photoswipe-thumb');
                }

                item.el = figureEl; // save link to element for getThumbBoundsFn
                items.push(item);
            }

            return items;
        };

        // find nearest parent element
        var closest = function closest(el, fn) {
            return el && (fn(el) ? el : closest(el.parentNode, fn));
        };

        // triggers when user clicks on thumbnail
        var onThumbnailsClick = function onThumbnailsClick(e) {

            e = e || window.event;
            e.preventDefault ? e.preventDefault() : e.returnValue = false;

            var eTarget = e.target || e.srcElement;

            // find root element of slide
            var clickedListItem = closest(eTarget, function (el) {
                return el.tagName && el.tagName.toUpperCase() === 'FIGURE';
            });

            if (!clickedListItem) {
                return;
            }

            // find index of clicked item by looping through all child nodes
            // alternatively, you may define index via data- attribute
            var clickedGallery = clickedListItem.parentNode,
                childNodes = clickedListItem.parentNode.childNodes,
                numChildNodes = childNodes.length,
                nodeIndex = 0,
                index;

            for (var i = 0; i < numChildNodes; i++) {
                if (childNodes[i].nodeType !== 1) {
                    continue;
                }

                if (childNodes[i] === clickedListItem) {
                    index = nodeIndex;
                    break;
                }
                nodeIndex++;
            }

            if (index >= 0) {
                // open PhotoSwipe if valid index found
                openPhotoSwipe(index, clickedGallery);
            }
            return false;
        };

        // parse picture index and gallery index from URL (#&pid=1&gid=2)
        var photoswipeParseHash = function photoswipeParseHash() {
            var hash = window.location.hash.substring(1),
                params = {};

            if (hash.length < 5) {
                return params;
            }

            var vars = hash.split('&');
            for (var i = 0; i < vars.length; i++) {
                if (!vars[i]) {
                    continue;
                }
                var pair = vars[i].split('=');
                if (pair.length < 2) {
                    continue;
                }
                params[pair[0]] = pair[1];
            }

            if (params.gid) {
                params.gid = parseInt(params.gid, 10);
            }

            return params;
        };

        var openPhotoSwipe = function openPhotoSwipe(index, galleryElement, disableAnimation, fromURL) {
            var pswpElement = document.querySelectorAll('.pswp')[0],
                gallery,
                options,
                items;

            items = parseThumbnailElements(galleryElement);

            // define options (if needed)
            options = {

                closeEl: true,
                captionEl: true,
                fullscreenEl: true,
                zoomEl: true,
                shareEl: false,
                counterEl: true,
                arrowEl: true,
                preloaderEl: true,

                showHideOpacity: true,

                // define gallery index (for URL)
                galleryUID: galleryElement.getAttribute('data-pswp-uid'),

                getThumbBoundsFn: function getThumbBoundsFn(index) {
                    // See Options -> getThumbBoundsFn section of documentation for more info
                    var thumbnail = items[index].el.getElementsByTagName('img')[0],
                        // find thumbnail
                    pageYScroll = window.pageYOffset || document.documentElement.scrollTop,
                        rect = thumbnail.getBoundingClientRect();

                    return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
                }

            };

            // PhotoSwipe opened from URL
            if (fromURL) {
                if (options.galleryPIDs) {
                    // parse real index when custom PIDs are used
                    // http://photoswipe.com/documentation/faq.html#custom-pid-in-url
                    for (var j = 0; j < items.length; j++) {
                        if (items[j].pid == index) {
                            options.index = j;
                            break;
                        }
                    }
                } else {
                    // in URL indexes start from 1
                    options.index = parseInt(index, 10) - 1;
                }
            } else {
                options.index = parseInt(index, 10);
            }

            // exit if index not found
            if (isNaN(options.index)) {
                return;
            }

            if (disableAnimation) {
                options.showAnimationDuration = 0;
            }

            // Pass data to PhotoSwipe and initialize it
            gallery = new photoswipe_default.a(pswpElement, photoswipe_ui_default_default.a, items, options);
            gallery.init();
        };

        // loop through all gallery elements and bind events
        var galleryElements = document.querySelectorAll(gallerySelector);

        for (var i = 0, l = galleryElements.length; i < l; i++) {
            galleryElements[i].setAttribute('data-pswp-uid', i + 1);
            galleryElements[i].onclick = onThumbnailsClick;
        }

        // Parse URL and open gallery if it contains #&pid=3&gid=1
        var hashData = photoswipeParseHash();
        if (hashData.pid && hashData.gid) {
            openPhotoSwipe(hashData.pid, galleryElements[hashData.gid - 1], true, true);
        }
    },
    addCode: function addCode() {
        var html = '\n            <!-- Root element of PhotoSwipe. Must have class pswp. #} -->\n            <div class="pswp" tabindex="-1" role="dialog" aria-hidden="true">\n              <div class="pswp__bg"></div>\n              <div class="pswp__scroll-wrap">\n                <!-- don\'t modify these 3 pswp__item elements, data is added later on. -->\n                <div class="pswp__container">\n                  <div class="pswp__item"></div>\n                  <div class="pswp__item"></div>\n                  <div class="pswp__item"></div>\n                </div>\n                <!-- Default (PhotoSwipeUI_Default) interface on top of sliding area. Can be changed. -->\n                <div class="pswp__ui pswp__ui--hidden">\n                  <div class="pswp__top-bar">\n                    <!-- Controls are self-explanatory. Order can be changed. -->\n                    <div class="pswp__counter"></div>\n                    <button class="pswp__button pswp__button--close" title="Close (Esc)"></button>\n                    <button class="pswp__button pswp__button--share" title="Share"></button>\n                    <button class="pswp__button pswp__button--fs" title="Toggle fullscreen"></button>\n                    <button class="pswp__button pswp__button--zoom" title="Zoom in/out"></button>\n                    <div class="pswp__preloader">\n                      <div class="pswp__preloader__icn">\n                        <div class="pswp__preloader__cut">\n                          <div class="pswp__preloader__donut"></div>\n                        </div>\n                      </div>\n                    </div>\n                  </div>\n                  <div class="pswp__share-modal pswp__share-modal--hidden pswp__single-tap">\n                    <div class="pswp__share-tooltip"></div>\n                  </div>\n                  <button class="pswp__button pswp__button--arrow--left" title="Previous (arrow left)">\n                  </button>\n                  <button class="pswp__button pswp__button--arrow--right" title="Next (arrow right)">\n                  </button>\n                  <div class="pswp__caption">\n                    <div class="pswp__caption__center"></div>\n                  </div>\n                </div>\n              </div>\n            </div>\n        ';

        document.body.insertAdjacentHTML('beforeend', html);
    },
    init: function init() {
        var gallery = document.querySelector('.js-imageGallery');
        if (gallery) {
            this.addCode();
            this.creatGallery('.js-imageGallery');
        }
    }
};
/* eslint-enable */
/* harmony default export */ var imageGallery__script = (imageGallery);
// EXTERNAL MODULE: ./node_modules/headroom.js/dist/headroom.js
var dist_headroom = __webpack_require__(239);
var headroom_default = /*#__PURE__*/__webpack_require__.n(dist_headroom);

// CONCATENATED MODULE: ./___src/templates/_organisms/pageHeader/_script.js
/**
 * pageHeader
 */


var pageHeader = {
    cfg: {
        header: '.js-pageHeader',
        class: '.o-pageHeader',
        headerOptions: {
            // vertical offset in px before element is first unpinned
            offset: 200,
            // scroll tolerance in px before state changes
            // tolerance : 0,
            // or scroll tolerance per direction
            tolerance: {
                down: 0,
                up: 0
            },
            classes: {
                // when element is initialised
                initial: 'is-animated',
                // when scrolling up
                pinned: 'is-down',
                // when scrolling down
                unpinned: 'is-up',
                // when above offset
                top: 'is-top',
                // when below offset
                notTop: 'is-notTop',
                // when at bottom of scoll area
                bottom: 'is-bottom',
                // when not at bottom of scroll area
                notBottom: 'is-notBottom'
            }
        }
    },

    init: function init() {
        // grab an element
        var header = document.querySelector(this.cfg.header);
        // construct an instance of Headroom, passing the element
        var headroom = new headroom_default.a(header, this.cfg.headerOptions);
        // initialise
        headroom.init();
    }
};
/* harmony default export */ var pageHeader__script = (pageHeader);
// EXTERNAL MODULE: ./node_modules/swiper/dist/js/swiper.js
var swiper = __webpack_require__(240);
var swiper_default = /*#__PURE__*/__webpack_require__.n(swiper);

// CONCATENATED MODULE: ./___src/templates/_organisms/pageCover/_script.js
function pageCover__script__toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/**
 * Image Slider
 */



var pageCover = {
    cfg: {

        slider: '.js-pageCover',
        sliderOptions: {
            // speed: 500,
            loop: false,
            autoplay: 3000,
            slidesPerView: 4,
            spaceBetween: 16,
            initialSlide: 2,
            autoplayDisableOnInteraction: false,
            // Arrows
            nextButton: '.swiper-button-next',
            prevButton: '.swiper-button-prev',
            breakpoints: {
                // when window width is <= 320px
                768: {
                    slidesPerView: 3
                },
                // when window width is <= 480px
                991: {
                    slidesPerView: 3
                },
                // when window width is <= 640px
                1199: {
                    slidesPerView: 3
                }
            },
            on: {
                init: function init() {
                    setTimeout(function () {
                        window.dispatchEvent(new Event('resize'));
                    }, 600);
                }
            }
        }
    },

    init: function init() {
        var _this = this;

        var sliders = [].concat(pageCover__script__toConsumableArray(document.querySelectorAll(this.cfg.slider)));
        if (sliders) {
            sliders.forEach(function (slider) {
                var mySwiper = new swiper_default.a(slider, _this.cfg.sliderOptions);

                mySwiper.update();

                setTimeout(function () {
                    mySwiper.update();
                }, 500);
            });
        }
    }
};

/* harmony default export */ var pageCover__script = (pageCover);
// CONCATENATED MODULE: ./___src/assets/js/partials/modules.js
/**
 * modules
 */



// import alert from '../../../templates/_molecules/alert/_script';
// import codeSnippet from '../../../templates/_atoms/codeSnippet/_script';





// import hamburger from '../../../templates/_molecules/hamburger/_script';
// import map from '../../../templates/_molecules/map/_script';
// import contactForm from '../../../templates/_organisms/contactForm/_script';
// import accordion    from '../../../templates/_templates/accordion/_main'
// import cookiebar    from '../../../templates/_organisms/cookiebar/_main';

// Modules Array
var modulesArray = [_script, toggle__script, imageCarousel__script["a" /* default */], imageSlider__script, imageGallery__script, pageHeader__script, pageCover__script];

var modules = {
    // Modules
    Modules: function Modules() {
        if (modulesArray.length > 0 && modulesArray !== undefined) {
            modulesArray.forEach(function (module) {
                module.init();
            });
        }
    },
    init: function init() {
        this.Modules();
    }
};

/* harmony default export */ var partials_modules = (modules);
// CONCATENATED MODULE: ./___src/assets/js/app.js
/**
 * Bundle Scripts
 */

// Polyfills




































































































// Import Libs


// CSS Import


// Import Partials




// import UIkit from './vendor/uikit';
// import Icons from './vendor/uikit-icons';

// loads the Icon plugin

var app_app = {
    init: function init() {
        partials_scripts.init();
        partials_templates.init();
        partials_modules.init();

        // UIkit.use(Icons);
    }
};

// Init App!
app_app.init();

/***/ })

},[99]);


// WEBPACK FOOTER //
// js/app.f5745b84b0dfb19658db.min.js